import styled from "styled-components";
import {SideSectionComponent} from "./side-section.component";

export const RightSectionComponent = styled(SideSectionComponent)`
    align-items: flex-end;
`
